import $ from "jquery";
// import CookieConsent from "@alpaga/cookie-consent";
import "./../styles/main.scss";
import Siema from "siema";
// require('./woocommerce/Global');
var Plyr = require("plyr");
require("jquery.scrollto");
require('./helpers/CookieConsent');
import Glide from "@glidejs/glide";
import AOS from "aos";
import Isotope from "isotope-layout";
import Rellax from "rellax";
import InView from "inview";
Siema.prototype.setAutoHeight = function (stopTime) {
    var that, timeout;
    that = this;
    function autoHeight() {
        var currentItems, min, max, itemHeightList, height, maxHeight, i;
        min = that.currentSlide;
        max = min + that.perPage;
        itemHeightList = [];
        for (i = min; i < max; i++) {
            height = parseInt(that.innerElements[i].scrollHeight, 10);
            itemHeightList.push(height);
        }
        maxHeight = Math.max.apply(null, itemHeightList);
        $(that.selector).height(maxHeight);
        that.sliderFrame.style.maxHeight = maxHeight + 'px';
    }
    window.addEventListener('resize', function () {
        that.sliderFrame.style.maxHeight = '';
        clearTimeout(timeout);
        timeout = setTimeout(autoHeight, 500);
    });
    autoHeight();
};
// require("is-in-viewport");
// import { siblings } from '@glidejs/glide/src/utils/dom';
$(document).ready(function () {
    var rellax = null;
    if ($('.rellax').length && $(window).width() > 768) {
        rellax = new Rellax('.rellax', {
            // speed: -2,
            center: true
            // center: false
        });
    }
    AOS.init({
        disable: 'mobile'
    });
    setTimeout(function () { AOS.refresh(); }, 500);
    $.extend($.scrollTo.defaults, {
        axis: 'y'
    });
    $('.player').each(function (k, e) {
        var player = new Plyr(e, {
        // controls: ['play', 'mute'],
        });
        player.volume = 0;
        if ($(e).hasClass("not-muted")) {
            player.volume = 1;
        }
        // if ($('.single-landingpage').length) {
        //     setTimeout(() => {
        //         player.volume = 1;
        //         player.play();
        //     }, 1000);
        // }
        if ($("#player-home").length) {
            var inview = InView($("#player-home").get(0), function (isInView) {
                if (isInView) {
                    if (player.playing == false) {
                        player.play();
                        // réactiver le volume à 1
                        player.volume = 1;
                    }
                }
                else {
                    if (player.playing == true) {
                        player.pause();
                    }
                }
            });
        }
    });
    if ($(".siema-manifeste").length) {
        var siemaManifeste_1 = new Siema({
            selector: ".siema-manifeste",
            draggable: false,
            onInit: function () {
            },
            onChange: function () {
                var posY = $("#manifeste").offset().top - $("#main-header").height() - 100;
                $.scrollTo(posY, 400);
                siemaManifeste_1.setAutoHeight();
            }
        });
        siemaManifeste_1.setAutoHeight();
        $("#manifeste").on("click", ".header a", function (e) {
            e.preventDefault();
            $("#manifeste").find(".header .current").removeClass("current");
            var index = $(e.currentTarget).parent().index();
            siemaManifeste_1.goTo(index);
            $(e.currentTarget).addClass("current");
        });
    }
    // const CookieConsentNode = new CookieConsent({
    //     locale : "en",
    //     cookies: {
    //         'necessary': {
    //             name: "necessary",
    //             disabled: true,
    //             value: true,
    //             title: "Necessary Cookies",
    //             description: "Necessary cookies help make a website usable by enabling basic\
    //             functions like page navigation and access to secure areas of the website. The website cannot\
    //             function properly without these cookies.",
    //             function: function() {},
    //             cookies: [
    //                 {
    //                     name : "CookieConsent",
    //                     provider : "cookieconsent.extension",
    //                     purpose : "Stores the user's cookie consent state for the current domain",
    //                     expiry : "1 year",
    //                     type : "HTTP",
    //                 },
    //             ]
    //         },
    //         analytics: {
    //             name: "analytics",
    //             value: true,
    //             title: "Analytics Cookies",
    //             function: function() {
    //             },
    //             description: "Analytic cookies help website owners to understand how visitors\
    //             interact with websites by collecting and reporting information anonymously.",
    //             cookies: [
    //                 {
    //                     name : "_ga",
    //                     provider : "Google",
    //                     purpose : "Registers a unique ID that is used to generate statistical data on how the visitor uses the website.",
    //                     expiry : "2 years",
    //                     type : "HTTP",
    //                 },
    //                 {
    //                     name : "_gat",
    //                     provider : "Google",
    //                     purpose : "Used by Google Analytics to throttle request rate",
    //                     expiry : "1 day",
    //                     type : "HTTP",
    //                 },
    //                 {
    //                     name : "_gid",
    //                     provider : "Google",
    //                     purpose : "Registers a unique ID that is used to generate statistical data on how the visitor uses the website.",
    //                     expiry : "1 day",
    //                     type : "HTTP",
    //                 }
    //             ]
    //         }
    //     }
    // });
    // CookieConsentNode.init();
    // const viewCookieBannerButton = document.querySelector(".view-cookie-banner");
    // if (viewCookieBannerButton !== void 0) {
    //     viewCookieBannerButton.addEventListener("click", (e) => {
    //         e.preventDefault();
    //         CookieConsentNode.showDetails();
    //     });
    // }
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    var hasBigLogo = false;
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#logo").toggleClass("show-menu");
        $("#nav-main").toggleClass("show-menu");
        $("#main-header").toggleClass("show-menu");
        if ($(window).scrollTop() < 150) {
            $("#logo").toggleClass("small");
        }
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("a[href='#applyjob']").on("click", function (e) {
        e.preventDefault();
        $(".content.form-wrapper").fadeIn(400);
        var posY = $(".content.form-wrapper").offset().top - $("#main-header").height() - 100;
        $.scrollTo(posY, 400);
    });
    if (location.hash !== void 0) {
        var node = location.hash;
        if (node != "") {
            var minus = $(window).width() < 600 ? 30 : 100;
            var posY = $(node).offset().top - $("#main-header").height() - minus;
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    }
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    $(window).scroll(function () {
        if ($(window).scrollTop() > 150) {
            $('#main-header').addClass('small');
        }
        if ($(window).scrollTop() < 150) {
            $('#main-header').removeClass('small');
        }
    });
    if ($(".page-template-tpl-home").length) {
        var h_1 = $(window).height();
        $(window).scroll(function () {
            if ($(window).scrollTop() > (h_1 / 3)) {
                $('#logo').addClass('small');
                $('main > header .baseline').css({ visibility: "hidden" });
            }
            if ($(window).scrollTop() < (h_1 / 3)) {
                $('main > header .baseline').css({ visibility: "visible" });
                $('#logo').removeClass('small');
            }
        });
    }
    if ($(".page-template-tpl-expertises").length) {
        $("#content").on("click", "h2", function (e) {
            if ($("#content h2.open").length && !$(e.currentTarget).hasClass("open")) {
                $("#content h2.open").toggleClass("open").next().slideUp(250);
            }
            $(e.currentTarget).toggleClass("open");
            $(e.currentTarget).next().slideToggle(250);
            setTimeout(function () {
                $.scrollTo($(e.currentTarget).offset().top - parseInt($(e.currentTarget).css("font-size")) - 15, 400);
            }, 250);
        });
    }
    var officeGlide = null;
    if ($('.carouselWrapper').length) {
        $('.carouselWrapper').each(function (k, e) {
            var customActiveClass = $(e).attr("data-custom-class") !== void 0 ? true : false;
            var gap = $(e).attr("data-gap") !== void 0 ? $(e).attr("data-gap") : 50;
            var view = $(e).attr("data-view") !== void 0 ? $(e).attr("data-view") : 2.5;
            var type = $(e).attr("data-type") !== void 0 ? $(e).attr("data-type") : "slider";
            var focus = $(e).attr("data-focus") !== void 0 ? $(e).attr("data-focus") : 0;
            var bound = $(e).attr("data-bound") !== void 0 ? $(e).attr("data-bound") : false;
            var autoplay = $(e).attr("data-autoplay") !== void 0 ? $(e).attr("data-autoplay") : false;
            var mobileGap = $(e).attr("data-mobile-gap") !== void 0 ? $(e).attr("data-mobile-gap") : 20;
            var mobileView = $(e).attr("data-mobile-view") !== void 0 ? $(e).attr("data-mobile-view") : 1;
            var mdGap = $(e).attr("data-md-gap") !== void 0 ? $(e).attr("data-md-gap") : gap;
            var mdView = $(e).attr("data-md-view") !== void 0 ? $(e).attr("data-md-view") : view;
            var smGap = $(e).attr("data-sm-gap") !== void 0 ? $(e).attr("data-sm-gap") : mdGap;
            var smView = $(e).attr("data-sm-view") !== void 0 ? $(e).attr("data-sm-view") : mdView;
            var glide = new Glide(e, {
                type: type,
                focusAt: focus,
                perView: view,
                gap: gap,
                startAt: 0,
                // bound: bound,
                bound: true,
                autoplay: autoplay,
                breakpoints: {
                    1050: {
                        gap: mdGap,
                        perView: mdView
                    },
                    768: {
                        gap: smGap,
                        perView: smView
                    },
                    600: {
                        focusAt: "center",
                        gap: mobileGap,
                        perView: mobileView
                    }
                }
            });
            if (customActiveClass) {
                // glide.mount({
                //     'CustomActiveClass': CustomActiveClass,
                // });
                glide.mount();
            }
            else {
                glide.mount();
            }
            if ($(e).attr("data-page") !== void 0) {
                officeGlide = glide;
            }
        });
    }
    $('.sliderWrapper').each(function (k, v) {
        var siema = $(v).find(".siema").get(0);
        var interval;
        var navigation = $(v).find(".navigation");
        var slider = new Siema({
            selector: siema,
            duration: 300,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: true,
            multipleDrag: false,
            threshold: 20,
            loop: true,
            rtl: false,
            onInit: function () {
                navigation.find("span:eq(0)").addClass("current");
            },
            onChange: function () {
                clearInterval(interval);
                interval = setInterval(function () { return slider.next(); }, 5000);
                navigation.find(".current").removeClass("current");
                navigation.find("span:eq(" + slider.currentSlide + ")").addClass("current");
            }
        });
        interval = setInterval(function () { return slider.next(); }, 5000);
        navigation.on("click", "span", function (e) {
            e.preventDefault();
            slider.goTo($(e.currentTarget).index());
        });
    });
    if ($("#jobs").length) {
        var $checkboxes = $('#filters input');
        var jobs_1 = $("#jobs");
        var items_1 = jobs_1.find(".carousel__slides").clone();
        $checkboxes.change(function (e) {
            jobs_1.find(".carousel__slides").html(items_1.html());
            var current = e.currentTarget.checked;
            var value = $(e.currentTarget).val();
            $(e.currentTarget).parent().parent().find("input:checked").prop("checked", false);
            $(e.currentTarget).prop("checked", current);
            if (officeGlide != null) {
                if (current) {
                    jobs_1.find(".job.item:not(" + value + "):not(.office-none)").parent().remove();
                }
                officeGlide.mount();
            }
        });
    }
    $("body").on("click", "#search-box > a", function (e) {
        e.preventDefault();
        $("#search-box").addClass("active");
        $("#search-box").find("input").trigger("focus");
    });
    $("body").on("click", "main", function (e) {
        if ($('#search-box').hasClass("active"))
            $("#search-box").removeClass("active");
    });
    if ($("#list-elements").length) {
        var grid = document.querySelector('#list-elements');
        // filter with selects and checkboxes
        var $selects = $('#filters select');
        var $checkboxes = $('#filters input');
        var iso = null;
        iso = new Isotope(grid, {
            itemSelector: '.item'
        });
        iso.layout();
        $selects.add($checkboxes).change(function (e) {
            var current = e.currentTarget.checked;
            $(e.currentTarget).parent().parent().find("input:checked").prop("checked", false);
            $(e.currentTarget).prop("checked", current);
            // map input values to an array
            var exclusives = [];
            var inclusives = [];
            // exclusive filters from selects
            $selects.each(function (i, elem) {
                if (elem.value) {
                    exclusives.push(elem.value);
                }
            });
            // inclusive filters from checkboxes
            $checkboxes.each(function (i, elem) {
                // if checkbox, use value if checked
                if (elem.checked) {
                    inclusives.push(elem.value);
                }
            });
            // first combine exclusives
            exclusives = exclusives.join('');
            var filterValue;
            if (inclusives.length) {
                // map inclusives with exclusives for
                filterValue = $.map(inclusives, function (value) {
                    return value + exclusives;
                });
                filterValue = filterValue.join('');
            }
            else {
                filterValue = exclusives;
            }
            console.log(filterValue);
            iso.arrange({
                filter: filterValue
            });
        });
        setTimeout(function () {
            iso.arrange();
        }, 500);
        if ($('#filters input:checked').length) {
            $checkboxes.trigger("change");
        }
    }
});
